import * as actionTypes from './actionTypes';
import api from "../../axios-cmk";
import moment from "moment";

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authDone = () => {
    return {
        type: actionTypes.AUTH_DONE
    };
};

export const authSuccess = (idToken) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: idToken,
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const auth = (email, password, isSignup) => {
    return dispatch => {
        dispatch(authStart());
        api.post('/auth/', {
            'username':email,
            'password':password
        }).then(response => {
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('expirationDate', moment(new Date()).add(1,'days'))
            dispatch(authSuccess(response.data.token));
        }).catch(err => {
            dispatch(authFail(err));
        });
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {
                const userId = localStorage.getItem('userId');
                dispatch(authSuccess(token, userId));
            }
        }
        dispatch(authDone());
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/auth.js